// extracted by mini-css-extract-plugin
export default {"Normal_Badge":"Badge_Normal_Badge__EKokA","IsCart_Badge":"Badge_IsCart_Badge__AOR9V","Badge":"Badge_Badge__x9+Ut"};